<div class=" maintenance-page">
  <span>
    This site is under maintenance.
  </span>
  <img src="assets/images/under_maintenance.png" />
</div>
